class ImageHotspotsSlider extends HTMLElement {
    connectedCallback() {
      this.initSlider();
      this.setupEditorHandlers();
    }
  
    initSlider() {
      const sliderEl = this.querySelector('.image-hotspots-slider');
      if (!sliderEl) return;
  
      let attempts = 0;
      const maxAttempts = 10;
  
      const tryInit = () => {
        if (typeof Swiper === 'undefined') {
          if (attempts++ < maxAttempts) {
            setTimeout(tryInit, 100);
          }
          return;
        }
  
        try {
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;

          const swiper = new Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            loop: true,
            allowTouchMove: isMobile,
            navigation: {
              nextEl: this.querySelector('.image-hotspots-button-next'),
              prevEl: this.querySelector('.image-hotspots-button-prev'),
            },
            pagination: {
              el: this.querySelector('.image-hotspots-pagination'),
              clickable: true,
            }
          });
  
          sliderEl.swiperInstance = swiper;
        } catch (e) {
          console.error('Failed to initialize hotspots slider:', e);
        }
      };
  
      tryInit();
    }

    setupEditorHandlers() {
      document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      document.addEventListener('shopify:section:select', this.handleSectionEvent.bind(this));
      document.addEventListener('shopify:block:deselect', this.handleSectionEvent.bind(this));
    }

    handleBlockSelect(event) {
      const slider = this.querySelector('.image-hotspots-slider');
      if (!slider?.swiperInstance) return;
      
      const targetElement = event.target;
      const slideElement = this.findSlideElement(targetElement, event);
      
      if (!slideElement) return;
      
      this.navigateToSlide(slider, slideElement);
    }

    findSlideElement(targetElement, event) {
      //Direct parent slide
      let slideElement = targetElement.closest('.swiper-slide');
      if (slideElement) return slideElement;
      
      //Look for slide by block ID
      const blockId = event.detail?.blockId;
      if (blockId) {
        const slideContainer = document.querySelector(`[data-slide-id="${blockId}"]`);
        if (slideContainer) {
          return slideContainer.closest('.swiper-slide');
        }
      }
      
      //Extract ID from element ID attribute
      if (targetElement.id) {
        const blockIdMatch = targetElement.id.match(/block-([a-f0-9-]+)/);
        const hotspotIdMatch = targetElement.id.match(/hotspot-([a-f0-9-]+)/);
        const extractedId = (blockIdMatch && blockIdMatch[1]) || (hotspotIdMatch && hotspotIdMatch[1]);
        
        if (extractedId) {
          const slideContainer = document.querySelector(`[data-slide-id="${extractedId}"]`);
          if (slideContainer) {
            return slideContainer.closest('.swiper-slide');
          }
        }
      }
      
      return null;
    }
    
    navigateToSlide(slider, slideElement) {
      // Get real slide index from data attribute (for loop mode)
      const realIndex = parseInt(slideElement.getAttribute('data-swiper-slide-index'), 10);
      
      if (!isNaN(realIndex)) {
        slider.swiperInstance.slideToLoop(realIndex);
        return;
      }
      
      // Fallback: find index among non-duplicate slides
      const allSlides = Array.from(slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
      const slideIndex = allSlides.indexOf(slideElement);
      
      if (slideIndex !== -1) {
        slider.swiperInstance.slideToLoop(slideIndex);
      }
    }
    
    handleSectionEvent(event) {
      const slider = this.querySelector('.image-hotspots-slider');
      if (slider?.swiperInstance) {
        slider.swiperInstance.update();
      }
    }
  }
  
  customElements.define('image-hotspots-slider', ImageHotspotsSlider);
  